const medicareAU = {
  green: 'Green',
  blue: 'Blue',
  yellow: 'Yellow',
};

export default medicareAU;
